import React, { useContext } from 'react';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import { ActiveCustomizeIndexContext } from '../states/ActiveCustomizeIndexProvider';
import classNames from 'classnames';
import classes from './TextEditor.module.scss';
import { hasSeverity } from '../validators/helpers/severity-checker';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostStatus } from '../../../models/graphql';
import { SlateWrapperViewProps } from './SlateWrapper/SlateWrapper.view';
import { PostEditorErrorKeys } from '../../../models/validator-props';
import { getCustomizationProfileId } from '../validators/helpers/customization-getter';
import { VariationsDropZone } from './VariationsDropZone';
import { POST_EDITOR_ERROR_CLASS } from '../../../constants/styleConstants';

export type TextEditorViewProps = {
  //
};

const warningList: PostEditorErrorKeys[] = [];

const errorList: PostEditorErrorKeys[] = [
  'pinterestDuplicatesCheck',
  'preventTwDuplicate',
  'scheduleTextOrMediaVariations'
];

export const TextEditorView = (): JSX.Element | null => {
  const customizeIndex = useContext(ActiveCustomizeIndexContext);
  const { state } = useContext(PostEditorContext);
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const postGroup = state.postGroups[postGroupIndex];
  const { posts, customizeContentPerProfile } = postGroup;
  const isCustomizingByProfile = customizeContentPerProfile && typeof customizeIndex === 'number';

  const customizedProfileId = getCustomizationProfileId(postGroup, customizeIndex);
  // const hashesByVariationId = getHashesByVariationId(texts, firstCommentText);

  const { errors } = postGroup;

  const isPostDraft = isCustomizingByProfile
    ? posts[customizeIndex].postStatus === PostStatus.DRAFT
    : postGroup.groupPostAttributes.postStatus === PostStatus.DRAFT;
  const hasTextError =
    !isPostDraft && hasSeverity(errors, ErrorMessageSeverity.error, customizedProfileId, null, errorList);
  const hastTextWarning =
    isPostDraft && hasSeverity(errors, ErrorMessageSeverity.warning, customizedProfileId, null, warningList);
  const boxClasses = classNames(classes.ContainerTextEditor, {
    [classes.ContainerTextEditorError]: hasTextError,
    [POST_EDITOR_ERROR_CLASS]: hasTextError,
    [classes.ContainerTextEditorWarning]: !hasTextError && hastTextWarning
  });

  let borderErrorType: SlateWrapperViewProps['borderErrorType'] = 'none';
  if (hasTextError) {
    borderErrorType = 'error';
  } else if (hastTextWarning) {
    borderErrorType = 'warning';
  }

  return (
    <>
      <div className={boxClasses}>
        <VariationsDropZone borderErrorType={borderErrorType} />
      </div>
    </>
  );
};
